import React from 'react';
import { DeliveryProvider } from '../Rest/Services/UserService/Data';
import novaPoshtaLogo from '../../../images/nova-poshta-logo.jpg';
import './DeliveryProviderIcon.css';

interface DeliveryProviderIconProps {
  provider: DeliveryProvider | string | number;
}

function DeliveryProviderIcon({ provider }: DeliveryProviderIconProps) {
  if (String(provider) === DeliveryProvider.NovaPost || String(provider) === '0') {
    return (
      <span className="delivery-provider-icon" aria-hidden="true">
        <img src={novaPoshtaLogo} alt="" className="delivery-provider-icon__image" />
      </span>
    );
  }

  if (String(provider) === DeliveryProvider.Self || String(provider) === '2') {
    return (
      <span className="delivery-provider-icon delivery-provider-icon--text" aria-hidden="true">
        С
      </span>
    );
  }

  return (
    <span className="delivery-provider-icon delivery-provider-icon--text" aria-hidden="true">
      У
    </span>
  );
}

export default DeliveryProviderIcon;
